<div class="button-badge">
  <ng-content></ng-content>
  @if (count(); as count) {
    <span class="badge">{{ count }}</span>
  }
</div>
